module.exports = __webpack_public_path__ + "img/ticket-back.fd5fe766.svg";